import script from "./mz.vue?vue&type=script&setup=true&lang=js"
export * from "./mz.vue?vue&type=script&setup=true&lang=js"

import "./mz.vue?vue&type=style&index=0&id=6626edff&lang=less"

const __exports__ = script;

export default __exports__